import React, { useState } from "react";
import "../SignUp.scss";
import AddressDetails from "./AddressDetails";
import { SignUpProvider } from "./contexts/SignUpContext";
import SetPassword from "./SetPassword";
import UserDetails from "./UserDetails";
import VerificationCode from "./VerificationCode";

const STEPS = {
  USER_DETAIL: "userdetail",
  VERIFICATION: "verification",
  SET_PASSWORD: "setpassword",
  SET_ADDRESS: "setaddress",
};

const WORKFLOW = {
  start: STEPS.USER_DETAIL,
  [STEPS.USER_DETAIL]: {
    next: STEPS.SET_ADDRESS,
  },
  [STEPS.SET_ADDRESS]: {
    next: STEPS.SET_PASSWORD,
    back: STEPS.USER_DETAIL,
  },
  [STEPS.SET_PASSWORD]: {
    next: STEPS.VERIFICATION,
    back: STEPS.SET_ADDRESS,
  },
};

const SignUp = (props) => {
  const [step, setStep] = useState(STEPS.USER_DETAIL);

  const cancelStep = () => {
    if ("back" in WORKFLOW[step]) {
      window.scrollTo(0, 0);
      setStep(WORKFLOW[step]["back"]);
    }
  };

  const nextStep = () => {
    if ("next" in WORKFLOW[step]) {
      window.scrollTo(0, 0);
      setStep(WORKFLOW[step]["next"]);
    }
  };

  // const formatPayload = (details) => {
  //   let formatedPayload = {
  //     email: details.companyEmail,
  //     firstName: details.firstName,
  //     lastName: details.lastName,
  //     dateOfBirth: details.dateOfBirth,
  //     employmentStartDate: details.employmentStartDate,
  //     company: companyName ? companyName : details.companyName
  //   };
  //   if ('addressDetails' in details && details.addressDetails) {
  //     formatedPayload = {
  //       ...formatedPayload,
  //       ...details.addressDetails
  //     };
  //   } else if (address) {
  //     formatedPayload = {
  //       ...formatedPayload,
  //       ...address
  //     };
  //   }
  //   return formatedPayload;
  // };
  return (
    <SignUpProvider>
      {step === STEPS.USER_DETAIL && (
        <UserDetails
          onSuccess={() => {
            nextStep();
          }}
        />
      )}
      {step === STEPS.SET_ADDRESS && (
        <AddressDetails
          onSuccess={() => {
            nextStep();
          }}
          onCancel={() => {
            cancelStep();
          }}
        />
      )}
      {step === STEPS.SET_PASSWORD && (
        <SetPassword
          onSuccess={() => {
            nextStep();
          }}
          onCancel={() => {
            cancelStep();
          }}
        />
      )}
      {step === STEPS.VERIFICATION && (
        <VerificationCode
          props={props}
          onCancel={() => {
            cancelStep();
          }}
        />
      )}
    </SignUpProvider>
  );
};

export default SignUp;
